import React, { useEffect, useRef } from "react";
import {
  GridCellProps,
  GridCustomCellProps,
  GridCustomHeaderCellProps,
  GridFilterChangeEvent,
  GridPageChangeEvent,
  Grid as KendoGrid,
  GridColumn as Column,
} from "@progress/kendo-react-grid";
import { GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Typography } from "@progress/kendo-react-common";
import AppDialog, { DialogCloseButton } from "../../components/dialog/Dialog";
import { MdDelete } from "react-icons/md";
import { Button } from "@progress/kendo-react-buttons";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeDialog, openDialog } from "../../components/dialog/dialogSlice";
import {
  CompositeFilterDescriptor,
  filterBy,
} from "@progress/kendo-data-query";
import {
  HeaderThElement,
  PagerTargetEvent,
} from "@progress/kendo-react-data-tools";
import { LoadingPanel } from "../../components/layout/Loading";
import IconButton from "../../components/common/IconButton";
import { getAllPurchases, deletePurchase } from "./services/purchase.services";
import { setPurchaseID, clearPurchaseID } from "./purchaseSlice";
import { checkAcessRights } from "../../_helper/helper";
import {
  DELETE_ACCESS,
  EDIT_ACCESS,
  INSERT_ACCESS,
} from "../../_contstants/common";
import { FiEdit } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const PurchaseList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isAddAccess = checkAcessRights(location.pathname, INSERT_ACCESS);
  const FilterPurchase = useAppSelector(
    (state) => state.purchase.FilterPurchase,
  );

  useEffect(() => {
    dispatch(getAllPurchases({ ...FilterPurchase }));
    return () => {
      dispatch(closeDialog());
    };
  }, [dispatch, FilterPurchase]);

  const handlePartyCreate = () => {
    navigate("/purchaseentry/create");
  };
  return (
    <>
      <DeletePurchaseDialog />
      <GridLayout cols={[{ width: "100%" }]}>
        <GridLayoutItem
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "4px 20px 20px 0",
          }}
        >
          <Typography.h4 style={{ marginBottom: 0, marginLeft: "3px" }}>
            Purchase List
          </Typography.h4>
          {isAddAccess && (
            <Button
              onClick={handlePartyCreate}
              fillMode={"solid"}
              themeColor={"primary"}
            >
              Add New Purchase
            </Button>
          )}
        </GridLayoutItem>
        <GridLayoutItem>
          <PurchaseGridComponent />
        </GridLayoutItem>
      </GridLayout>
    </>
  );
};

interface PageState {
  skip: number;
  take: number;
}

const initialDataState: PageState = { skip: 0, take: 10 };

const PurchaseGridComponent: React.FC = () => {
  const navigate = useNavigate();
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const isEditAccess = checkAcessRights(location.pathname, EDIT_ACCESS);
  const isDeleteAccess = checkAcessRights(location.pathname, DELETE_ACCESS);
  const PurchaseList = useAppSelector((state) => state.purchase.PurchaseList);
  const loading = useAppSelector((state) => state.purchase.loading);

  const [filter, setFilter] = React.useState<
    CompositeFilterDescriptor | undefined
  >(undefined);
  const [page, setPage] = React.useState<PageState>(initialDataState);
  const [pageSizeValue, setPageSizeValue] = React.useState<
    number | string | undefined
  >();

  const pageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent;
    const take =
      targetEvent.value === "All" ? PurchaseList.length : event.page.take;

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value);
    }
    setPage({
      ...event.page,
      take,
    });
  };

  const MyEditCommandCell = (props: GridCellProps) => {
    const handleEditItem = (ID: number) => {
      navigate("/purchaseentry/edit", { state: { ID } });
    };
    const handleOpenDeleteDialog = (ID: any) => {
      dispatch(openDialog("deletePurchase"));
      dispatch(setPurchaseID(ID));
    };
    return (
      <td
        className="action-td"
        style={{
          ...props.style,
        }}
      >
        {isEditAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Edit"
            themeColor="success"
            onClick={() => handleEditItem(props.dataItem.ID)}
          >
            <FiEdit
              className="absolute-position"
              style={{ fontSize: "20px" }}
            />
          </IconButton>
        )}
        {isDeleteAccess && (
          <IconButton
            type="button"
            fillMode="flat"
            size="small"
            title="Delete"
            themeColor="error"
            onClick={() => handleOpenDeleteDialog(props.dataItem.ID)}
          >
            <MdDelete
              className="absolute-position"
              style={{ fontSize: "24px" }}
            />
          </IconButton>
        )}
      </td>
    );
  };

  const handleFilterChange = (e: GridFilterChangeEvent) => {
    setFilter(e.filter);
    setPage({ skip: 0, take: page.take });
  };

  const HeaderCustomCell = (props: GridCustomHeaderCellProps) => (
    <HeaderThElement
      columnId={props.thProps?.columnId || ""}
      {...props.thProps}
      className="table-header"
    >
      {props.children}
    </HeaderThElement>
  );

  const CustomCell = (props: any) => {
    return (
      <td {...props.tdProps} colSpan={1} className={"table-cell"}>
        {props.children}
      </td>
    );
  };

  const MyDataCustomCell = (props: GridCustomCellProps) => (
    <CustomCell {...props} />
  );

  // const MyActiveInActiveCommandCell = (props: GridCellProps) => {
  //   const [IsActive, setIsActive] = useState<boolean>(props.dataItem.IsActive);

  //   const handleActiveInActive = () => {
  //     const newStatus = !IsActive;
  //     setIsActive(newStatus);
  //     const data = {
  //       ID: props.dataItem.ID,
  //       isActive: newStatus,
  //     };
  //     dispatch(purchaseActiveInactive(data)).then((response: any) => {
  //       if (response.payload?.data?.Status === 200) {
  //         dispatch(getAllPurchases({ ...FilterPurchase }));
  //       } else {
  //         // Revert on error
  //         setIsActive(!newStatus);
  //         dispatch(getAllPurchases({ ...FilterPurchase }));
  //       }
  //     });
  //   };

  //   return (
  //     <td style={{ textAlign: "center" }}>
  //       <Switch
  //         disabled={!isEditAccess}
  //         name="isactive"
  //         checked={IsActive}
  //         onChange={handleActiveInActive}
  //         size="small"
  //       />
  //     </td>
  //   );
  // };

  return (
    <>
      {loading && <LoadingPanel gridRef={gridRef} />}
      <KendoGrid
        scrollable="scrollable"
        style={{ maxHeight: "calc(100vh - 152px)" }}
        filterable={true}
        filter={filter}
        data={
          filter
            ? filterBy(PurchaseList, filter).slice(
                page.skip,
                page.take + page.skip,
              )
            : PurchaseList.slice(page.skip, page.take + page.skip)
        }
        onFilterChange={handleFilterChange}
        skip={page.skip}
        take={page.take}
        total={PurchaseList.length}
        pageable={{
          buttonCount: 5,
          pageSizes: [5, 10, 15, "All"],
          pageSizeValue: pageSizeValue,
          type: "input",
        }}
        onPageChange={pageChange}
        cells={{
          headerCell: HeaderCustomCell,
          data: MyDataCustomCell,
        }}
      >
        <Column
          field="ID"
          title="ID"
          width={80}
          cells={{
            data: (props: any) => (
              <td>
                <div
                  className="hoverableName"
                  onClick={() =>
                    navigate("/purchaseentry/edit", {
                      state: { ID: props.dataItem?.ID },
                    })
                  }
                >
                  {props.dataItem?.ID}
                </div>
              </td>
            ),
          }}
        />
        <Column field="InvoiceNo" title="Invoice No" />
        <Column field="Date" title="Date" />
        <Column field="VepariName" title="Party Name" />
        <Column field="PurchaseType" title="Purchase Type" />
        {/* <Column
          field="IsActive"
          title="Status"
          cells={{ data: MyActiveInActiveCommandCell }}
          width={"90px"}
          filterable={false}
        /> */}
        {(isEditAccess || isDeleteAccess) && (
          <Column
            field="ID"
            title="Actions"
            cells={{ data: MyEditCommandCell }}
            width={"110px"}
            filterable={false}
            locked={true}
          />
        )}
      </KendoGrid>
    </>
  );
};

const DeletePurchaseDialog: React.FC = () => {
  const dispatch = useAppDispatch();
  const PurchaseID = useAppSelector((state) => state.purchase.PurchaseID);
  const FilterPurchase = useAppSelector(
    (state) => state.purchase.FilterPurchase,
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);

  const handleDeleteAction = async (ID: number | null) => {
    if (ID) {
      const response = await dispatch(deletePurchase(ID));
      if (response.payload?.Data?.Status === 200) {
        dispatch(getAllPurchases({ ...FilterPurchase }));
        dispatch(closeDialog());
        dispatch(clearPurchaseID());
      } else {
        dispatch(getAllPurchases({ ...FilterPurchase }));
        dispatch(closeDialog());
        dispatch(clearPurchaseID());
      }
    }
  };

  return (
    <>
      {dialogName === "deletePurchase" && (
        <AppDialog>
          <>
            <Typography.h5>Delete Purchase?</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this purchase record?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                  gap: "8px",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => {
                    handleDeleteAction(PurchaseID);
                  }}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
    </>
  );
};

export default PurchaseList;
